import { ProgressIndicator } from '@/components/blocks/ProgressIndicator';
import { categoryContainerSX } from '@/components/content/Category/styles/container';
import { useCategory } from '@/data/Content/Category';
import { ID } from '@/data/types/Basic';
import { parseHTML } from '@/utils/parseHTML';
import { Box, Typography } from '@mui/material';
import { FC } from 'react';

export const CategoryLongDesc: FC<{
	id: ID;
}> = ({ id }) => {
	const { category, loading } = useCategory(id, undefined, true);

	return loading ? (
		<ProgressIndicator />
	) : category && category.longDescription ? (
		<Box sx={categoryContainerSX}>
			<Typography variant="body1">{parseHTML(category.longDescription ?? '')}</Typography>
		</Box>
	) : null;
};
